import { takeEvery, put, all } from 'redux-saga/effects';
import apiFetcher from '../../tools/api-fetcher';

import * as types from '../../actions/candidate/candidate-document-types/types';
import * as actions from '../../actions/candidate/candidate-document-types';

import handleError from '../../tools/error-helper';

function* getCandidateDocumentTypes() {
  yield put(actions.setLoading(true));
  try {
    const { data } = yield apiFetcher
      .auth()
      .get('/lookups/candidate-document-types');
    yield put(actions.setCandidateDocumentTypes(data));
  } catch (exception) {
    yield handleError(exception);
  }

  yield put(actions.setLoading(false));
}

export default function* candidateDocumentTypesSaga() {
  yield all([
    takeEvery(
      types.CANDIDATE_DOCUMENT_TYPES_GET_TYPES,
      getCandidateDocumentTypes
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-document-types.js